<template>
  <div class="legend">
    <svg
      v-bind:viewBox="'0,0,50,' + (10 + 10 * legendMarks.length)"
    >
      <g
        transform="translate(11,5)"
      >
        <yAxis
          v-bind:scale="legendScale"
          style="font-size: 0.45em;"
          transform="translate(1,-0.5)"
          orient="right"
          v-bind:format="format"/>
        <rect
          v-for="legend in colorLegendData"
          v-bind:key="legend.value"
          v-bind:fill="legend.value"
          fill-opacity="0.8"
          x="-10"
          width="10"
          v-bind:y="legendScale(isFinite(legend.key[0]) ? legend.key[0] : 0)"
          v-bind:height="legendScale(isFinite(legend.key[1]) ? legend.key[1] : legendMarks[legendMarks.length - 1]) - legendScale(isFinite(legend.key[0]) ? legend.key[0] : 0)"
        ></rect>
        <g
          v-bind:transform="'translate(0,' + (-5 + 10 * legendMarks.length) + ')'"
        >
          <rect
            fill="white"
            stroke="black"
            stroke-width=".25"
            x="-9.5"
            width="9"
            y=".5"
            height="9"
          ></rect>
          <line stroke="currentColor" y1="5" y2="5" x1="1" x2="7"></line>
          <text
            style="font-size: 6px;"
            x="10"
            y="7"
          >N/A
          </text>
        </g>
      </g>
    </svg>
  </div>
</template>
<script>
  import YAxis from '../charts/yAxis.vue'
  import * as d3 from 'd3'

  export default {
    name: 'Legend',
    components: { YAxis },
    props: [
      "colorLegendData",
      "format",
      "legendMarks",
    ],
    computed: {
      legendScale: function () {
        let r = this.legendMarks.map((_, i) => 10 * i)
        return d3.scaleOrdinal().range(r).domain(this.legendMarks)
      },
    },
  }
</script>
<style scoped>
  div.legend {
    width: 125px;
    max-width: 100%;
    background-color: white;
    opacity: 0.9;
    padding: 7px;
    margin: 0 10px 38px 0;
    pointer-events: auto;
    border-radius: 15px;
  }

  div.legend /deep/ text {
    font-size: smaller;
    transform: translate(-2px);
  }

</style>
